import { render, staticRenderFns } from "./PFSvgSIcon.vue?vue&type=template&id=2e179d5e&functional=true&"
import script from "./PFSvgSIcon.vue?vue&type=script&lang=js&"
export * from "./PFSvgSIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports